import React, { memo } from 'react';
import { Banner, MessageStatus } from '@nexus/lib-react/dist/core/Banner/Banner';
import styled from '@nexus/lib-react/dist/theme/styled';
import { SiteConfig } from '@olxeu-a2b/delivery-utils/typings/config';
import useI18n from '../../../../i18n/hooks/useI18n';
import Styled from './style/ActionKycRetry';
import S from './style/KycWarning';

const StyledBanner = styled(Banner)`
  display: flex;

  p {
    display: flex;
    flex-grow: 1;

    > div {
      display: flex;
      flex-grow: 1;
      justify-content: space-between;
      align-items: center;
    }
  }
`;

const KYCWarningUnified = ({
  sites,
}: {
  sites: {
    desktop: SiteConfig;
    mweb: SiteConfig;
    delivery: SiteConfig;
  };
}) => {
  const isMobileDomain = window.location?.href?.includes(sites.delivery.url);
  const i18n = useI18n();

  return (
    <S.BannerContainer>
      <S.BannerCentralizer>
        <StyledBanner type={MessageStatus.WARNING}>
          <S.MessageBlock>
            <S.WarningMessage>{i18n`dlv_orders_kyc_retry_needed`}</S.WarningMessage>
            <Styled.KYCRetryButton
              data-testid="kyc-retry-button-unfied"
              data-cy="kyc-retry-btn-unified"
              onClick={() =>
                window.location?.assign(
                  `${isMobileDomain ? sites.mweb.url : sites.desktop.url}/kyc/verification`,
                )
              }
            >
              {i18n`dlv_orders_kyc_retry`}
            </Styled.KYCRetryButton>
          </S.MessageBlock>
        </StyledBanner>
      </S.BannerCentralizer>
    </S.BannerContainer>
  );
};

export default memo(KYCWarningUnified);
